import connection from '../utils/api';

export const getItems = () => connection.get(`global-vars`);
export const setItem = (id, payload) => connection.post(`global-vars/${id}`, payload);